import React, { Component } from 'react';
import { theme, css } from 'constants';
import { Link, View, Text, isWeb, Animated, Easing } from 'core';
import { IcoNext } from 'icons';

const styles = css({
  icon: {
    marginHorizontal: 20
  },
  body: {
    flex: 1,
    minHeight: 70,
    borderBottomWidth: 1,
    borderColor: theme.gray_color_lighten(0.1),
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingRight: 10
  },
  bg: {
    backgroundColor: '#EEE',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
});
const lighten_gray = theme.gray_color_lighten(0.1);
export class ListItem extends Component {
  state = { fade_out: new Animated.Value(0) };

  componentDidUpdate(nProps) {
    const from = this.props.selected;
    const to = nProps.selected;
    from && !to && !isWeb && this.fadeOut();
  }

  fadeOut = () => {
    this.state.fade_out.setValue(1);
    Animated.timing(this.state.fade_out, {
      toValue: 0,
      duration: 1800,
      useNativeDriver: true,
      easing: Easing.quad
    }).start();
  };

  render() {
    const { selected, title, children, size, icon_style, ...props } = this.props;

    return (
      <Link
        animated={[styles.bg, { opacity: this.state.fade_out }]}
        underlayColor={lighten_gray}
        highlight
        size={size || 18}
        icon_style={[styles.icon, icon_style]}
        selected={selected}
        {...props}
      >
        <View style={styles.body}>
          <Text>{title}</Text>
          {children}
          {isWeb ? null : <IcoNext color={theme.gray_color_lighten(0.2)} />}
        </View>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/core/list_item.js